module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pager.pages && _vm.pager.pages.length) ? _c('ul', {
    staticClass: "pagination new-pager",
    style: (_vm.ulStyles)
  }, [_c('li', {
    staticClass: "total-content"
  }, [_vm._v("Total : " + _vm._s(_vm.totalJoinedRunner))]), _vm._v(" "), _vm._l((_vm.pager.pages), function(page, index) {
    return _c('li', {
      key: index + 1,
      staticClass: "page-item page-number",
      class: {
        'active': _vm.pager.currentPage === index + 1 && !_vm.isFilterOn
      },
      style: (_vm.liStyles)
    }, [_c('a', {
      staticClass: "page-link",
      style: (_vm.aStyles),
      on: {
        "click": function($event) {
          return _vm.setPage(index + 1, true)
        }
      }
    }, [_vm._v(_vm._s(page))])])
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19b8755f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forms/RunnerPagination.vue
// module id = 1669
// module chunks = 2